/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IExternalContent { }

   

    class ExternalContent implements IExternalContent {

        static controllerId: string = "externalContent";
        static $inject: Array<string> = ["common", "Restangular", "$location", "$sce", "$http"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        externalContentUrl: string = "";
        absUrl: string;
        showLeftSideBar: boolean = false;
        showRightSideBar: boolean = false;
        

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $location: ng.ILocationService, private $sce: ng.ISCEService, private $http: ng.IHttpService) {
            this.log = common.logger.getLogFn(ExternalContent.controllerId);
            this.logError = common.logger.getLogFn(ExternalContent.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(ExternalContent.controllerId, "success");

            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, ExternalContent.controllerId)
                .then(() => {
                    this.log("Activated ExternalContent View");
                });
        }

        loadExternalContent(){
           
           this.externalContentUrl = this.absUrl + "?absoluteurls=true";
        }

       
    }

    angular.module("app").controller(ExternalContent.controllerId, ExternalContent);
}